<template>
  <v-container fluid>
    <v-row class="mb-4">
      <v-col cols="12">
        <h1 class="text-h5 font-weight-bold">Panel de plataforma</h1>
        <p class="grey--text mb-0">Resumen de cuentas y negocios en la nube.</p>
      </v-col>
    </v-row>

    <v-row v-if="loading">
      <v-col cols="12" sm="6" md="3" v-for="i in 4" :key="i">
        <v-skeleton-loader type="card" />
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col cols="12" sm="6" md="3" v-for="card in statCards" :key="card.key">
        <v-card>
          <v-card-text class="d-flex justify-space-between align-center">
            <div>
              <div class="text-caption grey--text">{{ card.label }}</div>
              <div class="text-h5 font-weight-bold">{{ card.value }}</div>
            </div>
            <v-icon :color="card.color" large>{{ card.icon }}</v-icon>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-4">
      <v-col cols="12">
        <v-card>
          <v-card-title class="d-flex justify-space-between align-center">
            <span>Acciones rápidas</span>
          </v-card-title>
          <v-card-text>
            <v-btn color="primary" to="/platform/businesses/new">
              <v-icon left>mdi-plus</v-icon>
              Nuevo negocio
            </v-btn>
            <v-btn class="ml-2" outlined to="/platform/businesses">
              Ver todos los negocios
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { fetchPlatformStats } from '@/services/platform/businessService';

export default {
  name: 'PlatformDashboardView',
  data() {
    return {
      loading: true,
      stats: {
        total: 0,
        active: 0,
        suspended: 0,
        pending: 0,
        provisioningFailed: 0,
      },
    };
  },
  computed: {
    statCards() {
      return [
        { key: 'total', label: 'Total negocios', value: this.stats.total, icon: 'mdi-domain', color: 'indigo' },
        { key: 'active', label: 'Activos', value: this.stats.active, icon: 'mdi-check-circle-outline', color: 'green' },
        { key: 'suspended', label: 'Suspendidos', value: this.stats.suspended, icon: 'mdi-pause-circle-outline', color: 'orange' },
        { key: 'pending', label: 'Pendientes / Error', value: Number(this.stats.pending) + Number(this.stats.provisioningFailed), icon: 'mdi-alert-circle-outline', color: 'red' },
      ];
    },
  },
  async created() {
    try {
      const data = await fetchPlatformStats();
      this.stats = {
        total: Number(data.total || 0),
        active: Number(data.active || 0),
        suspended: Number(data.suspended || 0),
        pending: Number(data.pending || 0),
        provisioningFailed: Number(data.provisioningFailed || 0),
      };
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
    }
  },
};
</script>
